import { pageImages } from '@/pages/images';
var normalHearingIcon = pageImages.normalHearingIcon, mildHearingIcon = pageImages.mildHearingIcon, severeHearingIcon = pageImages.severeHearingIcon;
export var hearingLevelsExplained = [
    {
        title: 'Normal hearing',
        description: 'You can hear conversations with good clarity when there is background noise.',
        color: 'text-green',
        icon: normalHearingIcon,
    },
    {
        title: 'Mild hearing loss',
        description: 'You may have difficulty clearly following conversations when there is background noise.',
        color: 'text-orange',
        icon: mildHearingIcon,
    },
    {
        title: 'Moderate hearing loss',
        description: 'You have significant difficulty following conversations when there is background noise.',
        color: 'text-red',
        icon: severeHearingIcon,
    },
];
